import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { observer } from 'mobx-react-lite';
import { StyleSheet, View } from 'react-native';
import { FormatCard } from './step-cards/FormatCard';
import { neutrals } from 'src/theme/colors';
import { FormatInfo } from '@photosi/expo-photosi-sdk/build/PrintUtils';
import { useStore } from 'src/contexts/StoreContext';
import { GROUP_CODES } from 'src/constants/code.constants';

export const AvoidCuts = observer(({ card, productGroup }: { card: FormatInfo; productGroup: GROUP_CODES }) => {
  const { i18n } = useStore();
  return (
    <View style={style.container}>
      <View style={style.textContainer}>
        <TextLato style={style.title}>{i18n.t('modal-configuration-steps:avoid-cuts')}</TextLato>
        <TextLato style={style.description}>{i18n.t('modal-configuration-steps:avoid-cuts-description')}</TextLato>
      </View>
      <View style={style.cardContainer}>
        <FormatCard
          index={0}
          onPress={() => {}}
          item={card}
          isSelected
          onFocus={() => {}}
          productGroup={productGroup}
        />
      </View>
    </View>
  );
});

const style = StyleSheet.create({
  container: {
    paddingTop: 22,
    paddingBottom: 88,
    paddingHorizontal: 40,
    flexDirection: 'row',
  },
  textContainer: {
    gap: 24,
    flex: 1,
  },
  title: {
    fontWeight: 700,
    fontSize: 22,
    lineHeight: 28,
    color: neutrals.neutralGrays.graphite,
  },
  description: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 24,
    color: neutrals.neutralGrays.graphite,
  },
  cardContainer: {
    paddingLeft: 100,
    paddingRight: 60,
    pointerEvents: 'none',
    cursor: 'auto',
  },
});
